import React, { useContext } from 'react'
import { TermsConsent, TermsLink, PrivacyLink } from '@fs/identity.js'
import { Paragraph, Separator } from '@fs/zion-ui'
import { LiteContext } from '../context'

export default function LegalText() {
  const isLite = useContext(LiteContext)
  const termsLink = isLite
    ? 'https://cf.familysearch.org/cfprgm/legal/terms'
    : 'https://www.familysearch.org/legal/terms'
  const privacyLink = isLite
    ? 'https://cf.familysearch.org/cfprgm/legal/privacy'
    : 'https://www.familysearch.org/legal/privacy'

  return (
    <>
      <Separator />
      <Paragraph size="xs">
        <TermsConsent
          components={{
            TermsLink: <TermsLink wayfinding to={termsLink} id="terms-link" />,
            PrivacyLink: <PrivacyLink wayfinding to={privacyLink} id="privacy-link" />,
          }}
        />
      </Paragraph>
    </>
  )
}
